import { render, staticRenderFns } from "./SupplierPerformanceTable.vue?vue&type=template&id=1be0c52d&scoped=true"
import script from "./SupplierPerformanceTable.vue?vue&type=script&lang=js"
export * from "./SupplierPerformanceTable.vue?vue&type=script&lang=js"
import style0 from "./SupplierPerformanceTable.vue?vue&type=style&index=0&id=1be0c52d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be0c52d",
  null
  
)

export default component.exports